import { Component, Input } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ThemeService } from '@core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'tec-theme-switcher',
  templateUrl: './tec-theme-switcher.component.html',
  styleUrls: ['./tec-theme-switcher.component.scss'],
})
export class TecThemeSwitcherComponent {
  @Input()
  public showIcons = true;

  @Input()
  public classList = '';

  public isDarkThemeActive$: Observable<boolean>;
  public isLightThemeActive$: Observable<boolean>;
  constructor(private themeServices: ThemeService) {
    this.isDarkThemeActive$ = this.themeServices.darkThemeIsActive$;
    this.isLightThemeActive$ = this.themeServices.lightThemeIsActive$;
  }

  public useDarkTheme({ checked }: MatSlideToggleChange): void {
    if (checked) {
      this.themeServices.useDarkTheme();
    } else {
      this.themeServices.useLightTheme();
    }
  }
}
